// extracted by mini-css-extract-plugin
export default {"emailBodyTextarea":"EmailTool_emailBodyTextarea__wdehX","previewCard":"EmailTool_previewCard__hSoVh"};